export type TableVariant = 'bordered' | 'stripped';
